function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 382",
  fill: "none",
  stroke: "#3c00dc"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 274",
  d: "M13.821.5c0 1.945-9.511 5.316-13 4.241-.234 3.73-1.38 13.762 2.034 19.828s10.972 11.087 10.972 11.087 7.558-5.022 10.972-11.087 2.284-15.651 2.027-19.828C23.867 5.76 13.847 2.485 13.821.5z",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 291",
  d: "M23.74 12.414l-.855.058a4.3 4.3 0 00-4 4l-.058.857a.09.09 0 11-.18 0l-.058-.857a4.3 4.3 0 00-4-4l-.855-.058a.085.085 0 010-.17l.855-.058a4.3 4.3 0 004-4l.058-.855a.09.09 0 11.18 0l.058.855a4.3 4.3 0 004 4l.855.058a.085.085 0 110 .17z",
  strokeWidth: 0.5
}));

function SvgBadgeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.643,
    height: 36.156,
    viewBox: "0 0 27.643 36.156"
  }, props), _ref);
}

export default SvgBadgeinline;